import {Component, OnInit} from '@angular/core';
import {TranslateService} from "../../../services/translate.service";
import {CardsContent} from "../news/news.component";

@Component({
    selector: 'app-about',
    templateUrl: './about.component.html',
    styleUrls: ['./about.component.css']
})
export class AboutComponent implements OnInit {

    allAboutEng: CardsContent [] = [
        {
            title: 'In brief',
            date: '',
            avatar: '', alink: '',
            images: [],
            text: [
                '',
                'In brief. AHM is continue of psychology as a science that changed epoch.'
            ],
            links: []
        },
        {
            title: 'For different',
            date: '',
            avatar: '', alink: '',
            images: [],
            text: [
                '',
                'For different types of personality same event or case will cause different or opposite processes inside the psyche.',
                'That’s why starting psychoanalysis from something, but identifying types of personality, - glaring mistake.'
            ],
            links: []
        },
        {
            title: 'First famous',
            date: '',
            avatar: '', alink: '',
            images: [],
            text: [
                '',
                'First famous classification was from Karl Gustav Jung.',
                'But not full. Only few concepts. Not enough.',
                'Too inaccurate. The error is on average much greater than the percentage of correct results.'
            ],
            links: []
        },
        {
            title: 'Other important',
            date: '',
            avatar: '', alink: '',
            images: [],
            text: [
                '',
                'Other important step was made by Myers — Briggs Type Indicator (MBTI). They made Karl classification wider and got many types of personality.',
                'Every top manager of big company got this subject in education program for highest management.',
                'But basics of MBTI were not accurate and precise from scientific point of view. So. This classification does not accumulate all power of psychoanalysis.'
            ],
            links: []
        },
        {
            title: 'And AHM does!',
            date: '',
            avatar: '', alink: '',
            images: [],
            text: [
                '',
                'Basics were right and all process inside human psyche became clear and easy to understand, write or draw in the scheme/graph.'
            ],
            links: []
        },
        {
            title: 'Really skilled',
            date: '',
            avatar: '', alink: '',
            images: [],
            text: [
                '',
                'Really skilled professionals are agree in one thing. Person need to know so much to understand just a bit in psychology.',
                'AHM classification encapsulted all this \'too much\' and barriers in psychology became very low with AHM.',
                'But possibilities and power of use may be upgraded up to infinity.'
            ],
            links: []
        },
        {
            title: 'Does not matter',
            date: '',
            avatar: '', alink: '',
            images: [],
            text: [
                '',
                'Does not matter if you are professional psychologist/psychiatrist. Or top manager of billion scale company on the Wall Street.',
                'Psychoanalysis is key skill you need. And can be upgraded very much with visible effect. This site for everyone really successful.',
                'All top tools, professionals, communities, conventions and resources here. Based on the most powerful, accurate and full classification of personality types by AHM.'
            ],
            links: []
        },
        {
            title: 'Very popular direction',
            date: '',
            avatar: '', alink: '',
            images: [],
            text: [
                '',
                'Very popular direction today to handle everything connected with Your own psyche: growing, healing, goals achievement, personal therapy, recovering therapy...',
                'It is reality today. All effective methodics and tools are based on AHM classification. And all processes inside psyche are clear and understood for every action or event.',
                'It is unique and super important advantage available only by AHM.'
            ],
            links: []
        }
    ];

    allAboutRus: CardsContent [] = [
        {
            title: 'Вкратце',
            date: '',
            avatar: '', alink: '',
            images: [],
            text: [
                '',
                'АЧП - это продолжение психологии как науки, которое изменило эпоху.'
            ],
            links: []
        },
        {
            title: 'Для разных',
            date: '',
            avatar: '', alink: '',
            images: [],
            text: [
                '',
                'Для разных типов личности одно и то же событие или случай вызовет разные или противоположные процессы внутри психики.',
                'Вот почему начинать психоанализ, не выявляя типы личности участников, - грубая ошибка.'
            ],
            links: []
        },
        {
            title: 'Первая научная',
            date: '',
            avatar: '', alink: '',
            images: [],
            text: [
                '',
                'Первая научная и популярная классификация была от Карла Густава Юнга.',
                'Но она была не полной. Только несколько понятий. Недостаточно.',
                'Слишком неточная. Погрешность в среднем намного больше, чем процент верных результатов.'
            ],
            links: []
        },
        {
            title: 'Другой важный',
            date: '',
            avatar: '', alink: '',
            images: [],
            text: [
                '',
                'Другой важный для науки шаг был сделан типологией Майерс — Бриггс. Они расширили классификацию Карла и получили много типов личности.',
                'Каждый топ-менеджер крупной компании изучал этот предмет в образовательной программе для высшего руководства.',
                'Но основы MBTI не были точными с научной точки зрения. Поэтому классификация MBTI не содержит в себе всю силу психоанализа.'
            ],
            links: []
        },
        {
            title: 'А вот АЧП',
            date: '',
            avatar: '', alink: '',
            images: [],
            text: [
                '',
                'А вот АЧП содержит! Базовые понятия были правильными.',
                'Благодаря этому все процессы в человеческой психике стали ясными и простыми для понимания, написания или рисования на схеме/графике.'
            ],
            links: []
        },
        {
            title: 'Действительно квалифицированные',
            date: '',
            avatar: '', alink: '',
            images: [],
            text: [
                '',
                'Действительно квалифицированные специалисты согласны в одном. Человек должен знать очень много, чтобы хоть немного понимать в человеческой психике.',
                'Классификация АЧП инкапсулирует в себе все это «слишком много». Барьеры в психологии стали очень низкими с классификацией АЧП.',
                'Но повышение уровня психоанализа и сопутствующих навыков, а также мощь использования, могут быть доведены до бесконечности.'
            ],
            links: []
        },
        {
            title: 'Не имеет значения',
            date: '',
            avatar: '', alink: '',
            images: [],
            text: [
                '',
                'Не имеет значения. Вы профессиональный психолог/психиатр. Или топ-менеджер миллиардной компании на Уолл-стрит.',
                'Психоанализ - это ключевой навык, который вам нужен. И может быть сильно улучшен с видимым эффектом. Этот сайт для всех действительно успешных.',
                'Все лучшие инструменты, профессионалы, сообщества, конвенции и ресурсы здесь. На основе самой мощной, точной и полной классификации типов личности АЧП.'
            ],
            links: []
        },
        {
            title: 'Сегодня очень',
            date: '',
            avatar: '', alink: '',
            images: [],
            text: [
                '',
                'Сегодня очень популярное направление - брать под контроль все, что связано с Вашей собственной психикой: личный рост, лечение, достижение целей, личная терапия, восстановительная терапия ...',
                'Это реальность сегодня. Все эффективные методики и инструменты основаны на классификации АЧП.',
                'И все процессы внутри психики ясны и понятны в контексте каждого действия или события. Это уникальное и очень важное преимущество, доступное только АЧП.'
            ],
            links: []
        }
    ];

    constructor(private translate: TranslateService) {
    }

    ngOnInit() {
    }

    goLink(link: string) {
        setTimeout(() => {
            window.open(link, '_blank');
        }, 300);
    }

}
